import List from './list';

export default class MessageList extends List {
  onOpenContact = ({ contact }) => {
    let oldPartnerId = this.state.partnerId;
    let newPartnerId = contact.partnerId;
    this.setStateSilent({ current: newPartnerId + ':recent', partnerId: newPartnerId, contact });
    if (oldPartnerId !== newPartnerId) this.refresh(newPartnerId + ':recent');
  };

  mapItem = (item) => {
    item.own = item.from === this.userId;
    item.isRemoved = item.removed && item.removed.indexOf(this.userId) !== -1;
    if (!item.counter) item.counter = parseInt(item.id.toString().split('_')[1]);
    if (item.media?.length > 0) {
      item.imagesUri = item.media
        .filter((media) => media.fileType === 'image' && media.uri)
        .map((media) => media.uri);
    }
    if (item.state !== 'sending' && item.state !== 'error') item.state = 'sent';
    if (item.state === 'sent' && item.counter <= this.state.contact?.partnerLastRead)
      item.state = 'read';

    item.textOrigin = item.text;
    if (item.quoted) item.quoted.textOrigin = item.text;
    return item;
  };

  remapItems = () => {
    let listId = this.state.partnerId + ':recent';
    let items = this.items(listId);
    items = this._mapItems(items);
    this.setListStateSilent({ items }, listId);
  };

  onMessage = ({ channel, data: msgData }) => {
    let data = { ...msgData };
    let userId = this.userId;
    if (channel !== 'u-' + userId) return this.log('wrong channel');
    if (!this.filterItem(data)) return this.log('filtered');
    let { id, counter, tempId, from, to } = data;
    let partnerId = from === userId ? to : from;
    let listId = partnerId + ':recent';
    let current = this.state.partnerId;

    this.log('onMessage', { partnerId, from, to, id, tempId });
    let items = this.items(listId);
    var exist = false;
    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      if (
        item.state &&
        ((item.tempId && item.tempId === tempId) || (item.id && item.id === id)) &&
        item.from === from &&
        from === userId
      ) {
        exist = true;
        if (item.state === 'sending') {
          item.state = 'sent';
          item.id = id;
          item.counter = counter;
          item.updated = Date.now();
          if (data.media && data.media.length > 0) {
            item.media = data.media.map((media, index) => {
              return {
                ...media,
                uri: item.media[index].uri
              };
            });
            item.files?.forEach((file) => {
              let ext = file.name?.split('.').pop().toLowerCase();
              if (file.name?.indexOf('.') === -1) {
                ext = '';
              }
              let mediaFile = item.media.find((mf) => file.name === mf.originalName);
              if (mediaFile.fileProcessId) {
                file.fileProcessId = mediaFile.fileProcessId;
                file.selfDestruct = mediaFile.selfDestruct;
                file.deleteAt = mediaFile.deleteAt;
              }
              this.warn('socket update dicom', ext);
              if (file.isAudioRecording) {
                if (mediaFile?.peaks) file.peaks = mediaFile.peaks;
              } else if (!ext || ['zip', 'rar', '7z', 'dcm'].includes(ext)) {
                this.warn('socket update dicom 2', file, mediaFile);
                if (mediaFile?.isDicom) {
                  Object.keys(mediaFile).forEach((key) => {
                    if (key !== 'uri') file[key] = mediaFile[key];
                    if (file.file) file.file[key] = mediaFile[key];
                  });
                  this.warn('socket update dicom done', file);
                }
              }
            });
            this.setStateSilent({
              itemUpdated: Date.now()
            });
          }
          this.log('sent message updated by socket', item);
        } else {
          this.log('sent message found but already settled, ignoring by socket');
        }
        break;
      } else if (item.id === id) {
        exist = true;
        this.log('socket message duplicated');
        break;
      }
    }
    if (!exist) {
      this.log('socket message not found, adding');
      // delete data.tempId;
      data.own = data.from === userId;

      if (!data.own && (!current || current !== from || !this.state.isActive)) {
        if (this.user.desktopAlerts) {
          this.notification.sendNotification('New Message', data.text, data);
        }

        if (this.user.sound) {
          this.emit('playAlert');
        }
      }

      if (current === partnerId) {
        this.setStateSilent({
          contact: {
            ...this.state.contact,
            partnerTyping: 0
          }
        });
      }

      items.unshift(this.mapItem(data, -1, items));
      this.setListState({ items }, listId, null, this.state.partnerId !== partnerId);

      if (current === partnerId) this.emit('newMessage', data);
    }
  };

  onMessageUpdateWS = ({ data }) => this.onMessageUpdate(data);
  onMessageUpdate = (data) => {
    this.updateItem(data, { listId: data.partnerId + ':recent' });
    this.updateItem(data, { listId: data.partnerId + ':search' });
  };

  onSelectImage = async (image) => {
    let images = this.listGet('inputImages') || [];

    let item = {
      image,
      ...image
    };

    images.push(item);
    this.setListState({ inputImages: images, uploadIndex: Date.now() });
  };

  onCancelImage = (image) => {
    let preview = image.preview;
    let images = this.listGet('inputImages').filter((item) => item.preview != preview);
    this.setListState({ inputImages: images, uploadIndex: Date.now() });
  };

  handleChangeSearch = (text) => {
    this.cancelApi('search');
    this.setListStateSilent({ items: [] }, `${this.state.partnerId}:search`);
    let type = text.length > 0 ? 'search' : 'recent';

    this.setStateSilent({
      current: this.state.partnerId + ':' + type,
      [`${this.state.partnerId}:search`]: text,
      selectedMessages: [],
      quoteMessage: null,
      editMessage: null
    });

    clearTimeout(this.searchTimeout);
    if (text) {
      this.searchTimeout = setTimeout(this.search, 500);
    } else {
      delete this.searchTimeout;
    }
    this.listHandleChange('search', text);
  };

  search = () => {
    clearTimeout(this.searchTimeout);
    delete this.searchTimeout;
    let query = this.listInput('search').trim();
    if (!query) return;
    let searching = this.getApiState('search').loading;
    if (searching) return;
    this._apiList(this.state.partnerId + ':search', false);
  };

  noResults = () => {
    return (
      this.state.partnerId &&
      !this.refreshing() &&
      this.items().length === 0 &&
      (!this.listInput('search') || (this.listInput('search') && !this.searchTimeout))
    );
  };

  filterItem = () => true;

  onFilterOtherItem = (data, filter) => {
    data = this.mapItem(data);
    let userId = this.userId;
    const cb = (partnerId) => {
      let listId = partnerId + ':recent';
      if (this.listState[listId] && (!filter || filter(listId))) {
        let items = this.items(listId);
        let index = items.findIndex((item) => item.id === data.id);
        if (data.removedDate) {
          if (index > -1) items.splice(index, 1);
        } else {
          if (index < 0) items.unshift(data);
          else items[index] = { ...items[index], ...data };
        }
        this.setListState({ items: this.sort(items, this.sortBy) }, listId);
      }
    };
    if (data.notificationFrom === userId) {
      (data.sharedUserIds || data.userIds).map(cb);
    } else {
      cb(data.notificationFrom);
    }
    return false;
  };

  doctorIds = () => {
    const { user, contact } = this.state;
    return user?.isPatient ? user.doctorIds : contact?.isPatient ? contact?.doctorIds : [];
  };
}
